import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-circle-stop-lined",
  "use": "rt-base-circle-stop-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-circle-stop-lined\"><path d=\"M828.8 195.2c-174.9-174.9-458.6-174.9-633.6 0s-174.9 458.6 0 633.6 458.6 174.9 633.6 0 174.9-458.6 0-633.6zM249 249c135.7-135.7 350.2-144.6 496.3-26.8L222.2 745.3C104.4 599.2 113.3 384.6 249 249z m29.7 552.8l523.1-523.1C919.6 424.8 910.7 639.4 775 775s-350.2 144.6-496.3 26.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/circle-stop-lined.svg
// module id = 1710
// module chunks = 137